import type { CMSMenuItem } from '@/src/domains/cms-menus/schemas'
import { getLocalisedHref } from '@/src/domains/next-roots/utils/getLocalisedHref'

export const getCMSMenuItemHref = (item: CMSMenuItem) => {
  const url = item.url
  const page = item.page_relation_one

  if (page) {
    const isBusinessPage = page.category === 'business'
    const slug = page.slug

    if (isBusinessPage) {
      return getLocalisedHref('/business/[slug]', { slug })
    } else {
      return getLocalisedHref('/[slug]', { slug })
    }
  } else if (url) {
    return url
  } else {
    return '/'
  }
}
